import { Box, Text, Button } from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { calculateDateRange } from "../../redux/actions/actions";
import { deleteQuiz } from "../../redux/api_calls/apiCalls";
import IndividualQuizCard from "./IndividualQuizCard";

export default function AllQuizzes({ quizzes, method, loadMoreVisible }) {
    const dispatch = useDispatch()

    const deleteHandler = (id) => {
        let updatedQuizzes = quizzes.filter(quiz => quiz.id !== id)
        dispatch(deleteQuiz(updatedQuizzes, id))
    }

    return (
        <Box width={['90%', '85%', '80%', '80%']} flexDirection='column' justifyContent='space-between' alignItems='center' d={['none', 'none', 'none', 'flex']} mb='1.5rem' >
            <Box d={['none', 'none', 'none', 'flex']} width='100%' p='1rem'>
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='30%'>Quizzes</Text>
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='25%' textAlign='center'>Participants</Text>
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='20%' textAlign='center'>Questions</Text>
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='20%' textAlign='center'>Actions</Text>
            </Box>
            {
                quizzes.map((quiz) => <IndividualQuizCard
                    key={quiz.id}
                    name={quiz.title}
                    dates={quiz.start_date ? calculateDateRange(quiz.start_date, quiz.end_date.split(' ')[0]) : null}
                    participants={quiz.participants}
                    questions={quiz.question_count}
                    id={quiz.id}
                    removeQuiz={deleteHandler}
                />)
            }
            {
                loadMoreVisible &&
                <Button
                    color='#00000099'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    fontWeight='700'
                    fontSize={["12px", "14px", "16px", "18px"]}
                    border='2px solid rgba(0, 0, 0, 0.1)'
                    boxShadow='0px 3px 16px rgba(0, 0, 0, 0.1)'
                    borderRadius='xl'
                    py={['0.5rem', '0.75rem', '1rem', '1.5rem']}
                    px={['0.75rem', '1rem', '1.5rem', '2rem']}
                    m='2rem'
                    bg='#ffffff'
                    onClick = {method}
                >
                    Load More...
                </Button>
            }
        </Box>
    )
}